import { render, staticRenderFns } from "./LdLeadsPlusRetirementBanner.vue?vue&type=template&id=b9a56720&scoped=true"
import script from "./LdLeadsPlusRetirementBanner.vue?vue&type=script&lang=js"
export * from "./LdLeadsPlusRetirementBanner.vue?vue&type=script&lang=js"
import style0 from "./LdLeadsPlusRetirementBanner.vue?vue&type=style&index=0&id=b9a56720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a56720",
  null
  
)

export default component.exports